import { render, staticRenderFns } from "./ItemOptionStats.vue?vue&type=template&id=107aada3&scoped=true&"
import script from "./ItemOptionStats.vue?vue&type=script&lang=js&"
export * from "./ItemOptionStats.vue?vue&type=script&lang=js&"
import style0 from "./ItemOptionStats.vue?vue&type=style&index=0&id=107aada3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107aada3",
  null
  
)

export default component.exports